const enquiryFromWebEnquiryTemplate = `
<div class="ui-notification">
  <h3>New Enquiry Received</h3>
  <div class="message">
    You have been assigned a new Web Enquiry by {{sender}}
    <br />  

    <a class="btn btn-success" ui-sref="enquiryEdit({enquiryId: {{enquiryId}}})">View</a>
  </div>
</div>
`;

export default enquiryFromWebEnquiryTemplate;



// WEBPACK FOOTER //
// ./client/app/common/templates/notification/enquiryFromWebEnquiryTemplate.js